module.exports = __webpack_public_path__ + "img/img1.fd3ce7ce.jpg";